import { fetchUpcomingBookings as fetchUpcomingBookingsCall } from 'flux/clients/bookings';

import { CombinedActionTypes } from '../../actionsFactory';

export interface Actions {
  fetchUpcomingBookings: (options: { page: number; pageSize: number }) => void;
}

export default function actions(
  dispatch: (action: CombinedActionTypes) => void,
): Actions {
  return {
    fetchUpcomingBookings: ({ page, pageSize }) => {
      dispatch({ type: 'UPCOMING_BOOKINGS:FETCHING' });

      fetchUpcomingBookingsCall({ page, pageSize })
        .then((result) =>
          dispatch({
            type: 'UPCOMING_BOOKINGS:FETCHING_SUCCESS',
            payload: { result },
          }),
        )
        .catch((error) =>
          dispatch({
            type: 'UPCOMING_BOOKINGS:FETCHING_ERROR',
            payload: { error },
          }),
        );
    },
  };
}
